import React, { useState } from 'react';
import { useEffect } from 'react';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import { useRootContext } from '../partials/context/rootContext';

import MainChat from '../partials/components/mainChat';

const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: "100%"
    }
}));

const ChatLogs = ({ ...props }) => {
    const classes = useStyles();
    const [rooms, setRooms] = useState([]);
    const [currentRoom, setCurrentRoom] = useState({});

    useEffect(() => {
        setRooms(props.data.rooms);
        setCurrentRoom(props.data.rooms[0]);
    }, [props.data.rooms]);

    return (
        <div className="px-4 py-10 font-sans container h-screen">
            <h2 className="text-center text-xl lg:text-4xl font-bold text-gray-700 py-2 w-full">Chat Logs</h2>
            <FormControl variant="filled" className={classes.formControl}>
                <InputLabel id="demo-simple-select-filled-label">Room Channel</InputLabel>
                <Select
                    labelId="demo-simple-select-filled-label"
                    id="demo-simple-select-filled"
                    value={currentRoom}
                    onChange={(e)=>setCurrentRoom(e.target.value)}
                >
                    {
                        rooms.map((room, i) => <MenuItem key={i} value={room}>({moment(room.start).format("YYYY-MM-DD")}) {room.title} ({moment(room.start).format("h:mm A")})</MenuItem>)
                    }
                </Select>
            </FormControl>
            <MainChat attendee={props.data.attendee} currentRoom={currentRoom} />
        </div>
    );
};

export default ChatLogs;
